// extracted by mini-css-extract-plugin
module.exports = {"tag-wrap":"tag-wrap__118me","tag":"tag__2vqqV"};